var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 217,
    viewBox: "0 0 217 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 108.5,
    r: 108.5,
    fill: "#EFF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.656 73.8125H113.164C112.147 73.8158 111.152 73.5139 110.305 72.9453L104.332 68.9151C102.354 67.5805 100.028 66.8703 97.6483 66.875H81.3438C78.154 66.8784 75.0958 68.1586 72.8402 70.4347C70.5847 72.7108 69.316 75.7968 69.3126 79.0156V84.2187H158.688C158.688 77.5241 153.291 73.8125 146.656 73.8125ZM150.04 150.125H77.96C74.8031 150.121 71.7741 148.866 69.5263 146.629C67.2784 144.392 65.9917 141.354 65.9438 138.169L62.4762 102.454V102.393C62.3627 100.961 62.544 99.5217 63.0087 98.1643C63.4734 96.807 64.2115 95.5614 65.1765 94.506C66.1415 93.4505 67.3126 92.6081 68.616 92.0316C69.9194 91.4551 71.327 91.1571 72.7501 91.1562H155.272C156.694 91.1576 158.101 91.4561 159.404 92.0329C160.707 92.6096 161.878 93.4522 162.842 94.5076C163.807 95.563 164.545 96.8083 165.009 98.1654C165.473 99.5224 165.655 100.962 165.541 102.393V102.454L162.056 138.169C162.008 141.354 160.722 144.392 158.474 146.629C156.226 148.866 153.197 150.121 150.04 150.125Z",
    fill: "#D3D9DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.dbdd0b280350410ac7ce1ece7d842c0b.svg";
export { ForwardRef as ReactComponent };